/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChemoStartAdmAliases {
  DATE_START_ADM = 'date-start-adm',
  FIELD_HOR_ADM = 'field-hor-adm',
  FIELD_START_ADM = 'field-start-adm',
  FORM_START_ADM = 'form-start-adm',
  LAYOUT_0 = 'layout-0',
  PANEL_START_ADM = 'panel-start-adm',
  TIME_FIELD_ADM = 'time-field-adm',
}
export { ChemoStartAdmAliases };
